import { storeAddition } from "@/stores/addition.js";
import $axios from "@/axios";

export default {
  //請求分類
  get: async function () {
    await $axios
      .post("/api/admin/addition_get.php")
      .then(function (res) {
        if (res.data.result == "pass") {
          storeAddition.additions = res.data.additions;
        } else {
          console.log(res.data);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  },
};
